import { render, staticRenderFns } from "./RecibosView.vue?vue&type=template&id=907b08c0&scoped=true"
import script from "./RecibosView.vue?vue&type=script&lang=js"
export * from "./RecibosView.vue?vue&type=script&lang=js"
import style0 from "./RecibosView.vue?vue&type=style&index=0&id=907b08c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907b08c0",
  null
  
)

export default component.exports